import { useEffect, useState } from "react";
import WellnessLecutreDetailSkeleton from "../../components/skeleton/lecture/lectureDetailSkeleton";
import { useNavigate, useParams } from "react-router-dom";
import { isLogin, lectureDatePeriodFormat } from "../../utils";
import { ProgramInfoWithModal } from "./ui/programInfoWithModal";
import { Flex } from "antd";
import { WellnessLectureInfoRow } from "./ui/lectureInfoRow";
import dayjs from "dayjs";
import { BottomBtn, DividerThin } from "../../shared";
import { ClassDescription } from "./ui/classDescription";
import { ReactComponent as ArrowRight } from '../../assets/images/icon/arrow-right.svg';
import { CancelReservationWithModalInWellnessLectureDetail } from "./ui/modal/cancelReservationWithModalInLectureDetail";
import { ReservationWithModalInWellnessLectureDetail } from "./ui/modal/reservationWithModalInLectureDetail";
import { TopBar } from "../../widgets";
import { useMyContext } from "../../entities/context";
import { getWellnessLectureDetailByWellnessLectureId } from "../../service/wellnessLecture";
import { getAllIssuedWellnessTicketByMemberIdAndWellnessLectureId, setUrl } from "../../service";

const WellnessLecture = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [isInitLoading, setIsInitLoading] = useState<boolean>(true);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [wellnessLecture, setWellnessLecture] = useState<IWellnessLectureDetailWebResponseV2>();
    const [issuedWellnessTicketList, setIssuedWellnessTicketList] = useState<IIssuedWellnessTicketByMemberIdAndWellnessLectureIdResponseV2[]>([]);
    const { topHeight } = useMyContext();
    const path = window.location.pathname;

    useEffect(() => {
        requestWellnessLectureById();
    }, [id])

    const requestWellnessLectureById = async () => {
        if (!id) return;
        try {
            const res = await getWellnessLectureDetailByWellnessLectureId(id);
            setWellnessLecture(res.data)
            const img = new Image();
            if (res.data && res.data.wellnessLectureImageUrl) {
                img.src = res.data.wellnessLectureImageUrl
            } else {
                img.src = `https://img.positivehotel.io/2024/12/17/LectureDetailDefault.webp`
            }
            img.onload = () => {
                setImageLoaded(true);
            }

            if (!isLogin()) return;

            const res2 = await getAllIssuedWellnessTicketByMemberIdAndWellnessLectureId(id);
            setIssuedWellnessTicketList(res2.data)
        } catch (error) {
            console.error('error', error);
        }
    }

    useEffect(() => { if (imageLoaded) setIsInitLoading(false) }, [imageLoaded])

    const isCommunityProgram = !!wellnessLecture?.yogaProgramName.includes('Positive COMMUNITY');
    const ticketWord = isCommunityProgram ? '수강권' : '정기권';

    return <>
        {isInitLoading && <WellnessLecutreDetailSkeleton />}
        <TopBar
            position='fixed'
            title="수업 상세"
            rightIcon={false}
            thema='dark'
        />

        {wellnessLecture && <>
            <img style={{ width: "100%", objectFit: 'cover' }} alt="Not" src={wellnessLecture.wellnessLectureImageUrl ? wellnessLecture.wellnessLectureImageUrl : `https://img.positivehotel.io/2024/12/17/LectureDetailDefault.webp`} />

            <div style={{ padding: '24px 20px' }}>
                <ProgramInfoWithModal
                    name={wellnessLecture.yogaProgramName}
                    description={wellnessLecture.yogaProgramDescription}
                    title={wellnessLecture.yogaProgramName}
                />
                <div className="title/t2" style={{ marginTop: 8 }}>{wellnessLecture.wellnessLectureName}</div>
                <div style={{ height: 20 }}></div>

                <WellnessLectureInfoRow label="시간" value={lectureDatePeriodFormat(wellnessLecture.wellnessLectureStartDateTime, wellnessLecture.wellnessLectureEndDateTime)} />
                <WellnessLectureInfoRow label="장소" value={`${wellnessLecture.yogaCenterName} ${wellnessLecture.room}`} />
                <WellnessLectureInfoRow label="코치" value={`${wellnessLecture.teacherName} 코치`} />
                {wellnessLecture.isReservation && !!wellnessLecture.guestCount && <WellnessLectureInfoRow label="인원" value={`${wellnessLecture.guestCount + 1}명 (게스트 ${wellnessLecture.guestCount}명)`} />}

                <ClassDescription description={wellnessLecture.wellnessLectureDescription} />
                <DividerThin style={{ marginBlock: 20 }} />

                <Flex
                    style={{ justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                    onClick={() => navigate(`/teacher/${wellnessLecture.teacherId}`)}>
                    <div>
                        <div className="sub-title/st3">{wellnessLecture.teacherName} 코치</div>
                        <div className="body/b1 secondary/s700" style={{ marginTop: 8 }}>코치 소개 보기</div>
                    </div>
                    <ArrowRight width={16} height={16} stroke="#555555" style={{ paddingInline: 8 }} />
                </Flex>
            </div>

            {!isLogin()
                ? <BottomBtn text="먼저 로그인 하기" to={'/login'} onClick={() => { setUrl(path) }} />
                : dayjs().isAfter(dayjs(wellnessLecture.wellnessLectureStartDateTime))
                    ? <BottomBtn text="이미 지난 수업 입니다." />
                    : wellnessLecture.isReservation
                        ? <CancelReservationWithModalInWellnessLectureDetail
                            wellnessLecture={wellnessLecture}
                            requestWellnessLectureById={requestWellnessLectureById}
                        />
                        : wellnessLecture.isFullBooking
                            ? <BottomBtn text="정원 초과" />
                            : <ReservationWithModalInWellnessLectureDetail
                                wellnessLecture={wellnessLecture}
                                requestWellnessLectureById={requestWellnessLectureById}
                                issuedWellnessTicketList={issuedWellnessTicketList}
                                ticketWord={ticketWord}
                                purchasePath={isCommunityProgram ? `/popup/ticket/${id}` : `/wellness-ticket-group`} />
            }
        </>}
    </>
}

export { WellnessLecture }